import { Alert, Box, Button, Card, Heading, Text } from "@chakra-ui/react";
import { formatCalendarDate } from "../../contracts/columns";
import Kpi from "../components/Kpi";
import {
  enrollmentStatusLabel,
  formatCop,
  formatRate,
  rateFor,
  vatLabel,
} from "../format";
import type { SubmitResult } from "../types";

type Props = {
  batch: SubmitResult;
  withVat: boolean;
  onFinish: () => void;
};

// Its own tab, so an expired URL shows S3's error page there and this step,
// the only holder of the result, stays.
const openPdf = (url: string) => window.open(url, "_blank", "noopener");

// Shows what `submit` returned and nothing else: Estado and its date are the
// server's at submit, not the preview from Resumen.
const ClosingStep = ({ batch, withVat, onFinish }: Props): JSX.Element => (
  <Card.Root borderRadius="lg" border="none">
    <Card.Body p="5" display="flex" flexDirection="column" gap="4">
      <Box>
        <Heading size="xl">Recibimos tu solicitud</Heading>
        <Text color="gray.600">Este es el resumen de tu lote.</Text>
      </Box>
      <Alert.Root status="success" colorPalette="green" borderRadius="lg">
        <Alert.Indicator />
        <Alert.Content>
          <Alert.Title>¡Todo en orden!</Alert.Title>
          <Alert.Description>
            Alguien del equipo comercial de Palomma se pondrá en contacto lo
            antes posible para firmar el contrato y continuar el proceso.
          </Alert.Description>
        </Alert.Content>
      </Alert.Root>
      <Box
        display="grid"
        gridTemplateColumns={{
          base: "1fr",
          sm: "1fr 1fr",
          lg: "repeat(5, 1fr)",
        }}
        gap="3"
      >
        <Kpi label="Contratos" value={String(batch.contracts.length)} />
        <Kpi
          label={`Tasa (${vatLabel(withVat)})`}
          value={formatRate(rateFor(batch, withVat))}
        />
        <Kpi label="Valor a pagar / mes" value={formatCop(batch.monthlyCost)} />
        <Kpi label="Ahorro / año" value={formatCop(batch.monthlySaving * 12)} />
        <Kpi
          label="Estado según fecha"
          value={enrollmentStatusLabel(batch.enrollmentStatus)}
          note={`Desde ${formatCalendarDate(batch.effectiveDate)}`}
        />
      </Box>
      <Box display="flex" justifyContent="space-between" gap="3">
        <Button variant="outline" onClick={() => openPdf(batch.pdfUrl)}>
          Descargar resumen (PDF)
        </Button>
        <Button onClick={onFinish}>Finalizar</Button>
      </Box>
    </Card.Body>
  </Card.Root>
);

export default ClosingStep;
